module.exports = __webpack_public_path__ + "static/media/diktat-36.f6905034.mp3";